<template>
    <div>
        <card class="form-horizontal">
            <div class="card-header">
                <p style="color: white;"><span>Evaluaciones cerradas</span></p>
            </div>
            <div class="card-body text-center">
                <div class="row">
                    <el-table  :data="assesments"  ref="productsTable"  @row-dblclick="showAssesmentMethod" highlight-current-row @current-change="handleCurrentChange">
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <p>Cliente: {{ props.row.customerFirstName }} {{ props.row.customerSurname }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="Cliente" property="customerFullName"></el-table-column>
                        <el-table-column label="Monto">
                            <template slot-scope="scope">
                                <span >{{ setFormat(scope.row.amount)}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <div class="text-right">
            <!--<p-button type="warning">Siguiente</p-button>-->
            <p-button @click="toDashboard()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
    <script>
    import Vue from 'vue'
    import { Card } from 'src/components/UIComponents'
    import {Table, TableColumn} from 'element-ui'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    Vue.use(Table)
    Vue.use(TableColumn)
    export default {
        components: {
            Card
        },
        data() {
        return {
            products: [
                {
                    productName: 'Producto',
                    productDescription: 'Description'
                }   
            ],
            assesments: [],
            currentRow: null,
        }
        },
        computed: {
            
        },
        methods: {
            showAssesmentMethod (row) {
                this.$store.dispatch('setActualAssesment', row.id).then(()=>{
                    this.$router.push('/asessments/menu');
                });
            },
            handleCurrentChange(currentRow, oldCurrentRow) {
                this.currentRow = currentRow;
            },
            toPersonalData() {
                this.$store.dispatch('newAssesment').then(()=>{
                    this.$router.push('/asessments/new_asessment/customer/personal_data');
                });
            },
            toDashboard() {
                this.$router.push('/');
            },
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
        },
        mounted() {
            this.$store.commit('finishEvaluation', 'home');
            if (this.$store.state.assesments.length > 0) {
                for (let i=0;i<this.$store.state.assesments.length;i++) {
                    if (this.$store.state.assesments[i].finished) {
                        this.assesments.push({
                            id: i,
                            customerFullName: this.$store.state.assesments[i].customer.customerFirstName+' '+this.$store.state.assesments[i].customer.customerSurname,
                            customerFirstName: this.$store.state.assesments[i].customer.customerFirstName,
                            customerSurname: this.$store.state.assesments[i].customer.customerSurname,
                            amount: this.$store.state.assesments[i].amount
                        })
                    }
                }
            }
            else {
                this.assesments = this.$store.state.assesments;
            }
        }
    }
</script>
<style>
</style>
